import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AppDataService,
  GetCorePageDataService,
  FormBuildService,
  GlobalVariablesService,
  DocumentService,
  StepsService,
  StepRequest,
  StepResponse,
  TaxAndFeeItem
} from '@tmhcc-ng-lib/data-service';
import { FormBuilder } from '@angular/forms';
import {
  AppConfigService,
  SaveChangeGaurd
} from '@tmhcc-ng-lib/global-services';
import { Config, Menu } from '@tmhcc/artisan-edge';
import { BaseUCMFormsComponent } from '../base-ucm-forms.component';
import { UCMSharedService } from '../ucm-shared.service';
import { AccordionService } from '../../accordion-menu/accordion.service';
import { AutoDeclineService } from '../../common-liability/auto-decline/auto-decline.service';
import { SummaryContentService } from '@tmhcc-ng-lib/content-service';
import { StepNevigationService } from '../../common-liability/nevigation/step-nevigation.service';
import { TaxAndFeesType, UCMEventName } from '@tmhcc-ng-lib/models';

@Component({
  selector: 'ec-ucm-forms',
  templateUrl: './ec-ucm-forms.component.html',
  styleUrls: ['./ec-ucm-forms.component.scss']
})
export class ExposureChangeUCMComponent extends BaseUCMFormsComponent
  implements OnInit, AfterViewInit {
  apiEndpoint: string;
  apiKey: string;
  isFormRendered: boolean;
  hideTopSummary: boolean;
  coverageBtnStatus = '';
  readonlyStatus: boolean;
  disabledClass = '';
  policyType: string;

  constructor(
    protected router: Router,
    protected globalVariables: GlobalVariablesService,
    protected getSiteCoreDataService: GetCorePageDataService,
    protected ucmService: UCMSharedService,
    protected formBuildService: FormBuildService,
    protected loaderService: LoaderService,
    protected activeRouter: ActivatedRoute,
    protected documentService: DocumentService,
    protected appDataService: AppDataService,
    private formBuilder: FormBuilder,
    protected configService: AppConfigService,
    private saveChangeGaurd: SaveChangeGaurd,
    protected accordionService: AccordionService,
    protected stepsService: StepsService,
    protected autoDeclineService: AutoDeclineService,
    private summaryContentService: SummaryContentService,
    private cdref: ChangeDetectorRef,
    private stepNevigationService: StepNevigationService
  ) {
    super(
      router,
      globalVariables,
      getSiteCoreDataService,
      ucmService,
      formBuildService,
      loaderService,
      activeRouter,
      documentService,
      appDataService,
      autoDeclineService,
      stepsService,
      accordionService,
      configService
    );
    this.apiEndpoint = this.configService.config.dataServiceBaseUrl;
    this.apiKey = this.configService.config.dataServiceApiKey;
  }

  currentUrl = 'artisan';
  menus: Menu[];
  options: Config = { multi: false };
  summaryContent;
  summaryPanel: StepResponse;
  staticMenu = {
    sidemenu: [
      {
        active: true,
        iconClass: 'fa fa-globe',
        name: 'Exposure Change',
        submenu: [
          {
            heading: 'Payroll Receipts',
            image: null,
            name: 'Payroll Receipts',
            url: '/ec-ucm-forms/gl-payroll-receipt'
          },
          {
            heading: 'REVIEW & SUBMIT',
            image: null,
            name: 'Review & Submit',
            url: '/ec-ucm-forms/gl-review-submit'
          }
        ]
      }
    ]
  };

  ngOnInit(): void {
    this.appDataService.stepsSitecoreContent.next();

    this.initFormGroup();

    this.saveChangeGaurd.setFormGroup(this.ucmFormGroup);

    this.activeRouter.params.subscribe(params => {
      this.pageSettings.pageName = params['id'];
      this.loadSummarySections();
      this.loaderService.show();
      let payload: StepRequest = {
        policyId: this.globalVariables.policyId,
        versionNum: this.globalVariables.policyVersionId
      };
      this.stepsService.getPolicyDetails(payload).subscribe(res => {
        if (res) {
          this.appDataService.updatePolicyDetails(res);
          this.getCoveragesData(res);
          this.setExposureElementDefault(res);
          super.ngOnInit();
          this.loaderService.hide();
        }
      });
    });

    this.menus = this.staticMenu.sidemenu;

    this.appDataService.summarySitecoreContent.subscribe(r => {
      this.summaryContentService.data$.subscribe(res => {
        if (res) {
          this.summaryContent = res;
        }
      });
    });
  }

  setExposureElementDefault(policyDetails: StepResponse) {
    super.setElementDefault();

    this.elementDefaults.policyMaster = policyDetails.CurrentPolicyNum;
    this.elementDefaults.policyTxnNumPrior = policyDetails.PriorPolicyNum;

    if (this.pageSettings.pageName === 'gl-review-submit') {
      this.elementDefaults.additionalPremiumDue =
        policyDetails.ReviewAndSubmit?.AdditionalPremiumDue || '$0.00';
      this.elementDefaults.surplusLinesTax = this.getTaxAndFee(
        TaxAndFeesType.SurplusLinesTax,
        policyDetails.ReviewAndSubmit?.TaxAndFeeItems
      );
      this.elementDefaults.stampFee = this.getTaxAndFee(
        TaxAndFeesType.StampFee,
        policyDetails.ReviewAndSubmit?.TaxAndFeeItems
      );
      this.elementDefaults.total =
        policyDetails.ReviewAndSubmit.Total || '$0.00';
    }
  }
  getTaxAndFee(taxAndFeeType: string, taxAndFeeItems: TaxAndFeeItem[]) {
    if (taxAndFeeItems && taxAndFeeItems.length > 0) {
      let taxAndFee = taxAndFeeItems.find(
        taxFeeItem =>
          taxFeeItem.Name.toLowerCase() === taxAndFeeType.toLowerCase()
      );
      return taxAndFee?.Amount || '$0.00';
    }
    return '$0.00';
  }

  loadSummarySections() {
    this.globalVariables.isSummaryEnable == 'true';
    this.appDataService.summarySitecoreContent.next();
    this.appDataService.showSummary.next(true);
  }
  ngAfterViewInit() {}
  initFormGroup() {
    const controls = {};
    this.ucmFormGroup = this.formBuilder.group(controls);
  }

  getCoveragesData(data) {
    this.summaryPanel = data;
    this.loadSummarySections();
    this.cdref.detectChanges();
  }

  onFormEvent(event) {
    super.onFormEvent(event);

    if (
      event.eventName === UCMEventName.StepENExpNext ||
      event.eventName === UCMEventName.NextClicked
    ) {
      this.autoDeclineProcess(this.ucmFormGroup, event, true);
    }
  }
}
